import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ca-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingComponent {
  _rating = 0;
  stars: Array<string> = [];
  @Input()
  message: string;

  @Input()
  showNumber = true;

  @Input()
  set rating(r: number) {
    this._rating = r;
    if (r < 0.25) {
      this.stars = ['ca-star-o'];
      return;
    }
    const s = [];
    for (let i = 0; i < Math.floor(r); i++) {
      s.push('ca-star');
    }
    if (Math.round(r) > r) {
      s.push('ca-star-half');
    }
    this.stars = s;
  }
}
